import { combineReducers } from 'redux';

import shipments from 'state/direct-order-recurring/shipments';
import extras from 'state/direct-order-recurring/extras';
import repeatedFrom from 'state/direct-order-recurring/repeated-from';
import quote from 'state/direct-order-recurring/quote';
import insurance from 'state/direct-order-recurring/insurance';
import range from 'state/direct-order-recurring/range';
import days from 'state/direct-order-recurring/days';
import dropOff from 'state/direct-order-recurring/drop-off';
import holidays from 'state/direct-order-recurring/holidays';

import ui from 'state/direct-order-recurring/ui';

const data = combineReducers({
  shipments,
  extras,
  insurance,
  repeatedFrom,
  range,
  days,
  dropOff,
  holidays,
});

const reducer = combineReducers({
  data,
  ui,
  quote,
});

export default reducer;
